<template>
  <div class="m-bottom" v-lazy:background-image="{ src: require('@/assets/images/mobile/bottom.jpeg') }">
    <span class="m-bottom-jump1" @click="btnFn(11, policy1)"></span>
    <span class="m-bottom-jump2" @click="btnFn(21, policy2)"></span>
    <span class="m-bottom-jump3" @click="btnFn(31, policy3)"></span>
    <span class="m-bottom-jump4" @click="btnFn(41, policy4)"></span>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      btnobj: {
        'law_article_id': 11,
        'rule_article_id': 21,
        'special_law_article_id': 31,
        'fund_settlement_law_id': 41
      }
    };
  },
  computed: {
    ...mapState(["_myData"]),
    policy1() {
      return window.location.origin + '/protocol?id=' + this._myData.order.law_article_id;
    },
    policy2() {
      return window.location.origin + '/protocol?id=' + this._myData.order.rule_article_id;
    },
    policy3() {
      return window.location.origin + '/protocol?id=' + this._myData.order.special_law_article_id;
    },
    policy4() {
      return window.location.origin + '/protocol?id=' + this._myData.order.fund_settlement_law_id;
    },
  },
  created () {
  },
  mounted() {

  },
  methods: {
    btnFn(code, url) {
      window.open(url, "_self");
    }


  },
};
</script>

<style lang="scss" scope>
.m-bottom {
    @include wh(750, 210);
    margin: 0 auto;
    background-size: 100% 100%;
    background-position: center;
    position: relative;

    .m-bottom-jump1 {
      @include wh(160, 20);
      @include lt(15, 32);
    }
    .m-bottom-jump2 {
      @include wh(60, 20);
      @include lt(220, 32);
    }
    .m-bottom-jump3 {
      @include wh(190, 20);
      @include rt(230, 32);
    }
    .m-bottom-jump4 {
      @include wh(170, 20);
      @include rt(15, 32);
    }
}
</style>
